// extracted by mini-css-extract-plugin
module.exports = {"card":"VrH7Bshb","info":"mB2Lh2Yf","avatar":"i4rF8n3O","title":"O_V7okxq","action":"f0z0f93H","gallery":"cam4hOHJ","img":"Fe0M15z9","top":"wSMLbqDG","bottom":"__0GhXJylS"};